import { AppDispatch } from "app/store"
// eslint-disable-next-line no-restricted-imports
import { useDispatch as useReduxDispatch } from "react-redux"

export const useDispatch = () => useReduxDispatch<AppDispatch>()
